import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Typography,
} from '@material-ui/core';
import Info from '@material-ui/icons/Info';
import { ACKNOWLEDGEMENT_TEXT, ACKNOWLEDGEMENT_LABEL } from '../../constants';

interface AcknowledgementSectionProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}

export const AcknowledgementSection = ({
  checked,
  onChange,
  error,
}: AcknowledgementSectionProps) => {
  return (
    <Box className="apm-ack-section">
      <Box className="apm-ack-box">
        <Info className="apm-ack-icon" aria-hidden="true" />
        <Typography className="apm-ack-text">{ACKNOWLEDGEMENT_TEXT}</Typography>
      </Box>
      <FormControlLabel
        className="apm-checkbox-label"
        control={
          <Checkbox
            checked={checked}
            onChange={e => onChange(e.target.checked)}
            color="primary"
            size="small"
            aria-describedby={error ? 'acknowledgement-error' : undefined}
          />
        }
        label={ACKNOWLEDGEMENT_LABEL}
      />
      {error && (
        <FormHelperText id="acknowledgement-error" error>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
};
